import React from 'react'
import type { Img } from '@/services/images'

// Subtle photographer credit rendered under/over image galleries, per Unsplash TOS.
export function Attribution({ img, dark = false }: { img: Img; dark?: boolean }) {
  if (!img?.photographer) return null
  return (
    <a
      href={img.photographerUrl || '#'}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
      style={{
        fontFamily: 'var(--sans)',
        fontSize: 10,
        color: dark ? 'rgba(245,237,216,0.7)' : 'var(--dim)',
        textDecoration: 'none',
        opacity: 0.75,
      }}
    >
      Photo: {img.photographer}
    </a>
  )
}
